<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <CookieConsentBanner />
</template>

<script setup lang="ts">
const { initCategories } = useCategories()

await initCategories()
</script>
